import { render, staticRenderFns } from "./MenuSelectMobile.vue?vue&type=template&id=7365eecd&scoped=true&"
import script from "./MenuSelectMobile.vue?vue&type=script&lang=ts&"
export * from "./MenuSelectMobile.vue?vue&type=script&lang=ts&"
import style0 from "./MenuSelectMobile.vue?vue&type=style&index=0&id=7365eecd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7365eecd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
